module.exports = __webpack_public_path__ + "static/media/visit.b81a579f.jpg";